import Vue from 'vue';
import VueI18n from 'vue-i18n';
import moment from 'moment';
import 'moment/locale/pt-br';
import vuetifyPtBr from '@/plugins/i18n/vuetify/pt-br';
import vuetifyEn from '@/plugins/i18n/vuetify/en';
import ptBR from './locales/pt-BR';
import en from './locales/en';

// Idioma do cardápio (INTERNACIONALIZACAO_EUA_PLAN.md §4.4). O português é o texto de sempre; chave sem
// tradução em outro idioma cai no português, nunca na chave crua. Idioma novo = arquivo novo em locales/.

Vue.use(VueI18n);

export const IDIOMA_PADRAO = 'pt-BR';

export const IDIOMAS = {
    'pt-BR': { nome: 'Português', moment: 'pt-br' },
    en: { nome: 'English', moment: 'en' },
};

const CHAVE_ESCOLHA = 'idioma';

const i18n = new VueI18n({
    locale: IDIOMA_PADRAO,
    fallbackLocale: IDIOMA_PADRAO,
    silentFallbackWarn: true,
    messages: {
        'pt-BR': { ...ptBR, $vuetify: vuetifyPtBr },
        en: { ...en, $vuetify: vuetifyEn },
    },
});

export const idiomaValido = idioma => Object.prototype.hasOwnProperty.call(IDIOMAS, idioma);

/** Idiomas que a loja oferece: a lista configurada ou, sem ela, só o padrão da loja. */
export const idiomasDaLoja = config => {
    const padrao = idiomaValido(config?.idioma_cardapio) ? config.idioma_cardapio : IDIOMA_PADRAO;
    const lista = (config?.idiomas_cardapio || []).filter(idiomaValido);

    return lista.length > 1 ? lista : [padrao];
};

/** A escolha salva no aparelho, se a loja oferece esse idioma; senão o padrão da loja. */
export const idiomaInicial = config => {
    const oferecidos = idiomasDaLoja(config);
    const padrao = idiomaValido(config?.idioma_cardapio) ? config.idioma_cardapio : IDIOMA_PADRAO;

    let escolhido = null;
    try {
        escolhido = localStorage.getItem(CHAVE_ESCOLHA);
    } catch (e) {
        escolhido = null;
    }

    return oferecidos.includes(escolhido) ? escolhido : padrao;
};

export const salvarEscolha = idioma => {
    try {
        localStorage.setItem(CHAVE_ESCOLHA, idioma);
    } catch (e) {
        // Sem armazenamento (aba anônima, por exemplo): vale só nesta visita.
    }
};

export const aplicarIdioma = idioma => {
    const valido = idiomaValido(idioma) ? idioma : IDIOMA_PADRAO;

    i18n.locale = valido;
    moment.locale(IDIOMAS[valido].moment);
    document.documentElement.lang = valido;

    return valido;
};

export default i18n;
